import { EditPartnerActions } from "./EditPartnerAction";

const initialState = {
  editPartner: "",
  error: "",
};

const EditPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case EditPartnerActions.GET_PARTNER_VIEW_DETAILS_SUCCESS:
      return {
        ...state,
        editPartner: action.payload,
      };
    case EditPartnerActions.GET_PARTNER_VIEW_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
        editPartner: "",
      };
    default:
      return state;
  }
};

export default EditPartnerReducer;
